import React, { useState, useEffect } from 'react';

const Diaporama = () => {
  const [slides, setSlides] = useState([]);
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    fetch(`/assets/json/diapo.json?v=${Date.now()}`)
      .then(res => res.json())
      .then(data => setSlides(data))
      .catch(() => setSlides([]));
  }, []);

  useEffect(() => {
    if (slides.length === 0) return;
    const timer = setInterval(() => {
      setCurrent(prev => (prev + 1) % slides.length);
    }, 3000);
    return () => clearInterval(timer);
  }, [slides]);

  const goPrev = () => {
    setCurrent(prev => (prev - 1 + slides.length) % slides.length);
  };

  const goNext = () => {
    setCurrent(prev => (prev + 1) % slides.length);
  };

  if (slides.length === 0) return null;

  return (
    <div style={{ textAlign: 'center', margin: '2rem 0', position: 'relative' }}>
      <button
        onClick={goPrev}
        style={{
          position: 'absolute',
          left: 0,
          top: '45%',
          transform: 'translateY(-50%)',
          background: 'none',
          border: 'none',
          borderRadius: '50%',
          width: 36,
          height: 36,
          fontSize: 28,
          color: '#222',
          cursor: 'pointer',
          zIndex: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
        aria-label="Précédent"
      >
        ‹
      </button>
      <img
        src={slides[current].image}
        alt={slides[current].caption}
        style={{ maxWidth: '100%', height: '300px', objectFit: 'cover', borderRadius: '8px' }}
      />
      <button
        onClick={goNext}
        style={{
          position: 'absolute',
          right: 0,
          top: '45%',
          transform: 'translateY(-50%)',
          background: 'none',
          border: 'none',
          borderRadius: '50%',
          width: 36,
          height: 36,
          fontSize: 28,
          color: '#222',
          cursor: 'pointer',
          zIndex: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
        aria-label="Suivant"
      >
        ›
      </button>
      <div style={{ marginTop: '1rem', fontWeight: 'bold' }}>{slides[current].caption}</div>
    </div>
  );
};

export default Diaporama;
